<template>
  <div class="mt-0">
    <div class="main-wrapper">
      <div class="container">
        <!-- Header -->
        <div class="authentication-header">
          <div class="container">
            <div class="col-md-12">
              <div class="text-center">
                <img src="@/assets/img/logo.svg" alt="logo" />
              </div>
            </div>
          </div>
        </div>
        <!-- /Header -->

        <!-- Page Wrapper -->
        <div class="page-wrapper">
          <div class="content">
            <div class="maintenance">
              <div class="row">
                <div class="col-md-6 d-flex justify-content-center align-items-center">
                  <div class="maintenance-content">
                    <div class="maintenance-title">
                      <h1 class="display-6 mb-1">We're Down For Maintenance</h1>
                      <p class="fs-14">
                        Our website is currently undergoing scheduled maintenance, will be
                        right back in a few minutes.
                      </p>
                    </div>
                    <div class="maintenance-icons">
                      <h6>We'll Be Back Shortly</h6>
                      <div class="icons">
                        <a href="javascript:void(0);"
                          ><span><i class="fa-brands fa-facebook"></i></span
                        ></a>
                        <a href="javascript:void(0);"
                          ><span><i class="fa-brands fa-twitter"></i></span
                        ></a>
                        <a href="javascript:void(0);"
                          ><span><i class="fa-brands fa-instagram"></i></span
                        ></a>
                        <a href="javascript:void(0);"
                          ><span><i class="fa-brands fa-linkedin-in"></i></span
                        ></a>
                      </div>
                    </div>
                    <div class="maintenance-btn d-flex">
                      <a
                        href="javascript:void(0);"
                        class="btn btn-dark d-flex align-items-center"
                        ><i class="ti ti-circle-arrow-left me-1"></i>Back to Home</a
                      >
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="maintenance-img">
                    <img
                      src="@/assets/img/bg/maintenance.png"
                      alt="img"
                      class="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Wrapper -->
      </div>
    </div>
  </div>
</template>
